import User from '../models/User'
import isAdmin from './is-admin'
import isOperator from './is-operator'

export default function isStaff (user: User) {
  return isAdmin(user) || isOperator(user)
}
